<template>
  <form
      method="post"
      autocomplete="off"
      enctype="multipart/form-data"
      @submit.prevent="handleSubmit"
  >
      <div class="row py-2">
          <div class="col-md-12">
              <div class="form-group">
                  <label class="form-control-label text-muted" for="email"
                      >Location</label
                  >
                  <multiselect
                      placeholder=""
                      label="name"
                      track-by="id"
                      v-model="form.location"
                      :options="allLocations"
                      :multiple="false"
                      :show-labels="false"
                  >
                  </multiselect>

                  <span class="text-danger" v-if="v$.form.location.$errors">
                      {{ v$.form.location.$errors[0]?.$message }}
                  </span>
              </div>
          </div>
      </div>
      <div class="row py-2">
          <div class="col-md-12">
              <div class="form-group">
                  <label class="form-control-label text-muted" for="email"
                      >Minimum Quantity</label
                  >
                  <input
                      type="text"
                      v-model="form.quantity"
                      name="quantity"
                      class="form-control"
                  />

                  <span class="text-danger" v-if="v$.form.quantity.$errors">
                      {{ v$.form.quantity.$errors[0]?.$message }}
                  </span>
              </div>
          </div>
      </div>
      <button
          type="submit"
          class="mt-5 btn btn-outline-speq text-speq text-uppercase float-right"
      >
          {{ modalType == "edit" ? "Update Custom Rule" : "Add Custom Rule" }}
      </button>
  </form>

</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import Multiselect from "vue-multiselect";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
} from "@vuelidate/validators";


export default {
  props: [
    "modalType",
    "modalData",
    "modalSetting",
    "getResults",
    "allLocations",
  ],
  emits: ["closeModal"],
  components: {
      Multiselect,
  },
  setup() {
      const store = useStore();

      let user = computed(function () {
          return store.state.user;
      });

      let currentLocation = computed(function () {
          return store.state.currentLocation;
      });

      async function updateSetting(request) {
        return await store.dispatch("setLocationOrderMinimumQuantity", request);
      }

      return {
          user,
          currentLocation,
          updateSetting
      };
  },
  data() {
      return {
          v$: useVuelidate(),
          form: {
              id: null,
              location: null,
              quantity: 1,
          },
          submitted: false,
      };
  },
  validations() {
    return {
      form: {
        location: { required },
        quantity: { required }
      },
    };
  },
  mounted() {
      this.clearFields();
      // this.getAllLocations();

      if (this.modalType == "edit") {
          this.populateData();
      }
  },
  watch: {
      modalData(newval, oldval) {
          if (newval != oldval) {
              this.populateData();
          }
      },
  },
  methods: {
      handleSubmit(e) {
          this.submitted = true;

          this.v$.$validate();
          if (!this.v$.$error) {
              // if ANY fail validation
              this.addorUpdateSetting();
          } else {
              // alert('Form failed validation')
          }
      },
      async addorUpdateSetting() {
        let request = {
          location_id: this.form.location?.id,
          quantity: this.form.quantity,
        }

        await this.updateSetting(request);
        this.$emit("closeModal");
      },
      populateData() {
          this.form.id = this.modalData?.id;
          this.form.location = this.modalData?.location;
          this.form.quantity = this.modalData?.quantity;
      },
      clearFields() {
          this.form.location = null;
          this.form.quantity = 1;
      },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>